export default __webpack_public_path__ + "static/media/nbb_light.44dc9cdd.png";